import { createApp } from "vue";
import App from "@shared/App.vue";
import { i18n } from "@shared/app/i18n";
import router from "@shared/app/router";
import { createPinia } from "pinia";
import { validateEnv } from "@shared/app/env";
import { initVillus } from "@discover/shared/app/villus";
import { initFathom } from "@shared/app/fathom";
import { initGtm } from "@shared/app/gtm";
import { initParticles } from "@shared/app/particles";
import { initDash0 } from "@shared/app/dash0";

import "@shared/styles/defaults.css";
import "@discover/components/src/assets/styles/tailwind.css";
import "./assets/styles/index.css";

validateEnv(import.meta.env);

// We need to init dash0 before any lib that does any networking, otherwise
// Traceparent headers are not sent correctly.
initDash0();

const pinia = createPinia();

const app = createApp(App);

app
  .use(router)
  .use(initGtm())
  .use(i18n)
  .use(pinia)
  .use(initVillus())
  .use(initParticles())
  .mount("#app");

// Plugins require the above `app` context, and are instantiated afterwards.
initFathom();

export default app;
